import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '首页', path: '/' },
    { label: '分类浏览', path: '/categories' },
    { label: '文章中心', path: '/articles' },
    { label: '关于我们', path: '/about' },
  ],
  服务支持: [
    { label: '使用指南', path: '/articles' },
    { label: '功能介绍', path: '/categories' },
    { label: '最新版本', path: '/articles' },
    { label: '常见问题', path: '/about' },
  ],
  关于喑网91: [
    { label: '品牌介绍', path: '/about' },
    { label: '用户口碑', path: '/about#reputation' },
    { label: '联系方式', path: '/about#contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link
              to="/"
              className="text-xl font-bold text-white no-underline"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              喑网91
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              喑网91是您值得信赖的综合网络平台，致力于为用户提供优质、便捷、安全的在线服务体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-foreground-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-sm text-background-100"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-foreground-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-sm text-background-100"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 rounded-full bg-foreground-800 hover:bg-primary-500 flex items-center justify-center transition-colors duration-200"
                aria-label="QQ"
                rel="nofollow"
              >
                <i className="ri-qq-line text-sm text-background-100"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-white mb-4">
                {title}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-white transition-colors duration-200 no-underline"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 喑网91 版权所有 | 保留所有权利
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-white transition-colors no-underline" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="hover:text-white transition-colors no-underline" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="hover:text-white transition-colors no-underline" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}